module.exports = __webpack_public_path__ + "img/public/siteImages/stripImage.svg?28937cae";